import "@babel/polyfill";
import "mutationobserver-shim";

import Vue from "vue";
import moment from 'moment';
import App from "./App.vue";
import router from "./router";
import store from "./store";
import api from "./api";
import imagesService from "./images";
import utilsService from "./utils";

//-- BOOTSTRAP
import { BootstrapVue, IconsPlugin, ModalPlugin } from "bootstrap-vue";
// Install BootstrapVue
Vue.use(BootstrapVue);
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);
Vue.use(ModalPlugin);

//-- FONT AWESOME
import {
    faHome,
    faCircle,
    faInfo,
    faInfoCircle,
    faStar,
    faStore,
    faShoppingCart,
    faTruck,
    faBan,
    faMoneyBillAlt,
    faImages,
    faPlay,
    faTimes,
    faEnvelope,
    faUser,
    faArrowLeft,
    faCaretRight,
    faMinus,
    faPlus,
    faCheck,
    faCheckCircle,
    faChevronLeft,
    faChevronRight,
    faChevronDown,
    faTh,
    faThList,
    faSearch,
    faLink,
    faTag,
    faArrowsAlt,
    faTrash,
    faPencilAlt,
    faEuroSign,
    faUndo,
    faExclamationTriangle,
    faCopy,
    faComments,
    faQuestionCircle,
    faPhone,
    faPlayCircle,
    faEllipsisH,
    faArrowsAltH,
    faSortAlphaDown,
    faSortAlphaDownAlt,
    faSortNumericDown,
    faSortNumericDownAlt,
    faUserTimes,
    faFileAlt,
    faFilePdf,
    faInbox
} from "@fortawesome/free-solid-svg-icons";
import { faPaypal, faProductHunt } from "@fortawesome/free-brands-svg-icons";

import { library } from "@fortawesome/fontawesome-svg-core";
library.add(
    faHome,
    faCircle,
    faInfo,
    faInfoCircle,
    faStar,
    faStore,
    faShoppingCart,
    faTruck,
    faBan,
    faMoneyBillAlt,
    faImages,
    faPlay,
    faTimes,
    faEnvelope,
    faUser,
    faArrowLeft,
    faCaretRight,
    faMinus,
    faPlus,
    faCheck,
    faCheckCircle,
    faChevronLeft,
    faChevronRight,
    faChevronDown,
    faTh,
    faThList,
    faSearch,
    faLink,
    faTag,
    faArrowsAlt,
    faTrash,
    faPencilAlt,
    faEuroSign,
    faPaypal,
    faUndo,
    faExclamationTriangle,
    faCopy,
    faComments,
    faQuestionCircle,
    faPhone,
    faPlayCircle,
    faEllipsisH,
    faArrowsAltH,
    faSortAlphaDown,
    faSortAlphaDownAlt,
    faSortNumericDown,
    faSortNumericDownAlt,
    faUserTimes,
    faFileAlt,
    faFilePdf,
    faProductHunt,
    faInbox
);
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
Vue.component("font-awesome-icon", FontAwesomeIcon);

//-- HEADFUL (set page title and other metatags)
import vueHeadful from "vue-headful";
Vue.component("vue-headful", vueHeadful);

//-- INFINITE SCROLL
import infiniteScroll from "vue-infinite-scroll";
Vue.use(infiniteScroll);

//-- I18N
import VueI18n from "vue-i18n";
import messages from "./lang";
Vue.use(VueI18n);

export const i18n = new VueI18n({
    locale: "it",
    fallbackLocale: "it",
    messages
});

//-- HTML TO PAPER
import VueHtmlToPaper from "vue-html-to-paper";
Vue.use(VueHtmlToPaper, {
    name: '_blank',
    specs: [
      'fullscreen=yes',
      'titlebar=yes',
      'scrollbars=yes'
    ],
    styles: [
      //'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
      //'https://unpkg.com/kidlat-css/css/kidlat.css'
    ]
  });

//-- SENTRY
import * as Sentry from "@sentry/browser";
//import { Integrations } from "@sentry/tracing";

Sentry.init({
    Vue: Vue,
    dsn: process.env.VUE_APP_SENTRY_DSN,
    release: "rikordaeventi@" + process.env.VERSION,
    environment: process.env.NODE_ENV == 'production' ? 'production' : 'development',
    logErrors: true,
    /*integrations: [
        new Integrations.BrowserTracing(),
    ],*/
    // We recommend adjusting this value in production, or using tracesSampler
    // for finer control
    tracesSampleRate: 1.0,
});

Vue.config.productionTip = false;

//-- GLOBAL VARS
Vue.prototype.$sentry = Sentry;
Vue.prototype.$api = api;
Vue.prototype.$imagesService = imagesService;
Vue.prototype.$utilsService = utilsService;

//-- FILTERS
Vue.filter("toCurrency", function(value) {
    if (typeof value !== "number") {
        return value;
    }
    var formatter = new Intl.NumberFormat("it-IT", {
        style: "currency",
        currency: "EUR",
        minimumFractionDigits: 2
    });
    return formatter.format(value);
});

/*Vue.filter("formatDateOld", function(value) {
    if (typeof value !== "string" || value.length === 0) {
        return value;
    }
    var date = new Date(value.replace(/\s/, 'T'));
    var dateTimeFormat = new Intl.DateTimeFormat("it", {
        year: "numeric",
        month: "long",
        day: "2-digit"
    });
    var [
        { value: day },
        { value: literal },
        { value: month },
        { value: literal2 },
        { value: year }
    ] = dateTimeFormat.formatToParts(date);
    return day + " " + month + " " + year;
});*/

Vue.filter("formatDate", function(value) {
    moment.locale('it');
    let date = moment(String(value));
    return date.isValid() ? date.format('DD MMM YYYY') : value;
});

/*Vue.filter("formatDateSlash", function(value) {
    if (typeof value !== "string" || value.length === 0) {
        return value;
    }
    var date = new Date(value);
    var dateTimeFormat = new Intl.DateTimeFormat("it", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit"
    });
    var [
        { value: day },
        { value: literal },
        { value: month },
        { value: literal2 },
        { value: year }
    ] = dateTimeFormat.formatToParts(date);
    return day + "/" + month + "/" + year;
});*/

Vue.filter("formatDateSlash", function(value) {
    let date = moment(String(value));
    return date.isValid() ? date.format("DD/MM/YYYY") : value;
});

Vue.filter('toCamelCase', function (str) {
    return str.toLowerCase().replace(/(?:^|\s)\S/g, function(a) { return a.toUpperCase(); });
});

//-- IMPORT CSS
import(/* webpackChunkName: "style" */ "./assets/css/reset.css");
import(/* webpackChunkName: "style" */ "bootstrap/dist/css/bootstrap.css");
import(/* webpackChunkName: "style" */ "bootstrap-vue/dist/bootstrap-vue.css");
import(/* webpackChunkName: "style" */ "./assets/css/global.css");
import(/* webpackChunkName: "style" */ "./assets/css/tema-01.css");

//-- DIRECTIVES
Vue.directive("visible", function(el, binding) {
    el.style.visibility = binding.value === true ? "visible" : "hidden";
});

//-- VALIDATORI
import { extend } from 'vee-validate';

extend('validEmail', {
    validate: value => {
        return new Promise((resolve, reject) => {
            var isValid = false,
                EMAIL_REGEXP = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if (value.length === 0 || !EMAIL_REGEXP.test(value)) {
                resolve(isValid);
            } else {
                api.validateEmailAddress(value).then(response => {
                    isValid = response && response.isValid;
                    resolve(isValid);
                });
            }
        });
    },
    message: "Email non valida."
});

extend('validVatOrTaxCode', {
    validate: value => {
        return new Promise((resolve, reject) => {
            var isValid = utilsService.isValidVat(value) || utilsService.isValidTaxCode(value);
            resolve(isValid);
        });
    },
    message: "Valore non valido. Inserire la partita iva o il codice fiscale."
});

extend('validTaxCode', {
    validate: value => {
        return new Promise((resolve, reject) => {
            var isValid = utilsService.isValidTaxCode(value);
            resolve(isValid);
        });
    },
    message: "Valore non valido. Inserire un codice fiscale corretto."
});

extend('validVat', {
    validate: value => {
        return new Promise((resolve, reject) => {
            var isValid = utilsService.isValidVat(value);
            resolve(isValid);
        });
    },
    message: "Valore non valido. Inserire una partita iva corretta."
});

//-- GOOGLE TAG MANAGER
import VueTagManager from "vue-tag-manager"

// Do this before creating the Vue app
if (location.hostname === "www.rikordaeventi.it") {
    Vue.use(VueTagManager, {
        gtmId: 'GTM-PFNXTM8'
    });
}

//-- VUE INIT & MOUNT
new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount("#app");

console.debug("*** NODE_ENV:" + process.env.NODE_ENV);
//console.debug("*** BASE_URL:" + process.env.BASE_URL);
//console.debug("*** VUE_APP_API_BASE_URL:" + process.env.VUE_APP_API_BASE_URL);
